import { FC, useContext } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContextSemPaginacao,
  initialQueryResponseSemPaginacao,
  QUERIES,
  showError,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { useParametrosIndicadores } from './QueryRequestProvider'
import { IndicadoresOperacionais, ParametrosIndicadores } from './_models'
import { getIndicadoresOperacionais } from './_requests'

const QueryResponseContext = createResponseContextSemPaginacao<IndicadoresOperacionais>(
  initialQueryResponseSemPaginacao
)

/** Montado só dentro da aba Operacional: a request existe apenas enquanto a aba está na tela. */
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { parametros, query } = useParametrosIndicadores()

  const { isFetching, refetch, data } = useQuery(
    [QUERIES.INDICADORES_OPERACIONAIS, query],
    () => getIndicadoresOperacionais(parametros as ParametrosIndicadores),
    {
      enabled: Boolean(parametros),
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      onError: showError,
    }
  )

  return (
    <QueryResponseContext.Provider
      value={{
        isLoading: isFetching,
        refetch,
        singleResponse: data,
        query,
      }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
